<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Insurance Patients",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect
  },
  data() {
    return {
      filtered_array: [],
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Insurance Patients",
      items: [
        {
          text: "Account Section",
          href: "#/",
        },
        {
          text: "Insurance Patients",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patient",
          sortable: true,
          label: "CLIENT NAME",
        },
        {
          key: "contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "company",
          sortable: true,
          label: "INSURANCE COMPANY",
        },
        {
          key: "total",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "pay_status",
          sortable: true,
          label: "PAY STATUS",
        },
        {
          key: "services_view",
          sortable: true,
          label: "SERVICES",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],

      // FILTER
      filterreport: {
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
        company_id: "",
      },
      // PATTIENT SERVCES
      patient_services: {
        name: "",
        services: [],
      },
      // CLOSE VISIT
      close_visit: {
        patient_name: "",
        visit_id: "",
      },
      // END CLOSE VISIT
      //   ============================= EXPORT ==============================
      json_fields: {
        CLIENT_NAME: "patient",
        CONTACT: "contact",
        INSURANCE_COMPANY: "company",
        AMOUNT: "total",
        DATE: "date",
        PAY_STATUS: "pay_status",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("insurance", ["InsurancePatients", "InsuranceCompanies"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filtered_array ? this.filtered_array.length : 1;
    },
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    InsurancePatients(newValue) {
      if (newValue.length > 0) {
        this.set_insurance_patients();
      }
    },
  },

  mounted() {
    // Set the initial number of items
    this.totalRows = this.filtered_array ? this.filtered_array.length : 1;
  },
  methods: {
    yes(dd) {
      alert(dd);
    },
    ...mapActions({
      FetchInsurancePatients: "insurance/fetchInsurancePatients",
      FetchInsuranceCompanies: "insurance/fetchInsuranceCompanies",
      CloseVisit: "visits/closeVisit",
    }),

    set_insurance_patients() {
      this.filtered_array = this.InsurancePatients;
    },
       FilterRepo() {
      let startDate = this.filterreport.date1;
      let endDate = this.filterreport.date2;
      let company_id = this.filterreport.company_id;

      if (startDate != "" && endDate != "" && company_id !="") {
        this.filtered_array = this.InsurancePatients.filter((pymts) => {
          return pymts.filter_date >= startDate && pymts.filter_date <= endDate &&pymts.company_id == company_id;
        });
      } else if (startDate == "" && endDate != "" && company_id !="") {
        this.filtered_array = this.InsurancePatients.filter((pymts) => {
          return pymts.company_id == company_id && pymts.filter_date <= endDate;
        });
      } else if (startDate != "" && endDate != "" && company_id =="") {
           this.filtered_array = this.InsurancePatients.filter((pymts) => {
          return pymts.filter_date >= startDate && pymts.filter_date <= endDate;
        });
      } else {
        this.filtered_array = this.InsurancePatients;
      }
    },

    // patient_services
    patient_servicesmodel(data) {
      let serv_data = {
        name: data.patient,
        services: data.services,
      };
      this.patient_services = serv_data;
    },
    // END patient_services
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // CLOSE VISIT
    close_visit_mode(data, index) {
      this.close_visit.patient_name = data.patient;
      this.close_visit.visit_id = data.visit_id;
      this.close_visit.index = index;
    },
    ClosePatientVisit() {
      this.CloseVisit(this.close_visit.visit_id);
      this.closeMode("modal-close_visit");
      this.$store.commit("insurance/REMOVE_VIST_OBJECT", this.close_visit.index);
      this.FetchInsurancePatients();
    },
  },
  created() {
    this.set_insurance_patients();
    this.FetchInsurancePatients();
    this.FetchInsuranceCompanies();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <router-link to="/insurance/invoices" v-if="user_permissions.view_invoice">
        <button class="btn btn-info mb-2 float-end">
          View Insurance Invoices <i class="fa fa-arrow-circle-right"></i></button
      ></router-link>
    </div>
    <div class="row">
      <div class="col-md-4 form-group">
        <label>FROM</label>
        <input @change="FilterRepo()" v-model="filterreport.date1" type="date" class="form-control m-1" />
      </div>
      <div class="col-md-4 form-group">
        <label>TO</label>
        <input @change="FilterRepo()" v-model="filterreport.date2" type="date" class="form-control m-1" />
      </div>
      <div class="form-group col-md-4">
        <label class="col-form-label" for="userName"
          >Insurace Company <span class="text-danger">*</span>
        </label>
        <model-list-select
          @input="FilterRepo()" 
          :isError="false"
          :list="InsuranceCompanies ? InsuranceCompanies : []"
          v-model="filterreport.company_id"
          option-value="id"
          option-text="companyName"
          placeholder="select Company"
        >
        </model-list-select>
      </div>
    </div>
    <div class="row">
      <div class="form-group">
        <download-excel
          class="btn btn-primary mb-1 float-start"
          :data="filtered_array"
          :fields="json_fields"
          :worksheet="'Insurance patients ' + currentdate"
          type="csv"
          :name="'insurancepatients' + currentdate + '.xls'"
        >
          Export Excel <i class="fa fa-download"></i>
        </download-excel>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filtered_array ? filtered_array : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(services_view)="data">
                  <button
                    v-if="user_permissions.view_insurance_patient_services"
                    v-b-modal.modal-lg
                    class="btn btn-primary btn-sm"
                    @click="patient_servicesmodel(data.item)"
                  >
                    View
                  </button>
                  <button v-else disabled class="btn btn-primary btn-sm">
                    <i class="fa fa-ban"></i> View
                  </button>
                </template>
                <template #cell(actions)="data">
                  <button
                    v-if="user_permissions.close_insurance_patient_visits"
                    v-b-modal.modal-close_visit
                    class="btn btn-danger btn-sm"
                    @click="close_visit_mode(data.item, data.index)"
                  >
                    Close
                  </button>
                  <button v-else disabled class="btn btn-danger btn-sm">
                    <i class="fa fa-ban"></i> Close
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- VIEW SERVICES model -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal
                    id="modal-lg"
                    size="lg"
                    :title="'SERVICES FOR ' + patient_services.name.toUpperCase()"
                    title-class="font-18"
                    hide-footer
                  >
                    <div class="table-responsive">
                      <table class="table table-bordered border-primary mb-0">
                        <thead>
                          <tr>
                            <th>SERVICE</th>
                            <th>AMOUNT</th>
                            <th>STATUS</th>
                            <th>TIME</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(serv, index) in patient_services.services"
                            :key="index"
                          >
                            <td>{{ serv.service ? serv.service : "--" }}</td>
                            <td>{{ serv.cost ? serv.cost : "--" }}</td>
                            <td>{{ serv.status ? "Done" : "Pending..." }}</td>
                            <td>{{ serv.date ? serv.date : "--" }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- END VIEW SERVICES model-->

            <!-- CLODE VISIT MODEL -->

            <b-modal
              id="modal-close_visit"
              size="sm"
              :title="'Close ' + this.close_visit.patient_name + ' Visit'"
              title-class="font-18"
              hide-footer
            >
              <p class="text-danger">
                Are you sure you want to close <b>{{ this.close_visit.patient_name }}</b
                >'s visit
              </p>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary float-start"
                  @click="closeMode('modal-close_visit')"
                >
                  cancel
                </button>
                <button
                  type="submit"
                  @click="ClosePatientVisit()"
                  class="btn btn-success"
                >
                  close visit
                </button>
              </div>
            </b-modal>

            <!-- END CLODE VISIT MODEL -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
